import axios from "axios";
import { BASE_URL } from "./ApiEndPonts";

// // 🔐 Get token from localStorage
// function getToken() {
//   try {
//     const data = localStorage.getItem("accessToken");

//     console.log("TOKEN axios:", data);
//     // const parsed = data ? JSON.parse(data) : null;

//     // console.log("TOKEN:", parsed?.accessToken);

//     // return parsed?.accessToken || "";
//     return data || "";
//   } catch (err) {
//     return err;
//   }
// }

// 🌐 Axios instance
const axiosHttp = axios.create({
  baseURL: BASE_URL,
  timeout: 50000,
  withCredentials : true, // for cookie
});

// // 📤 Request interceptor (token attach)
// axiosHttp.interceptors.request.use(
//   (config) => {

//     const token = getToken();
//     console.log("API URL:", config.url);
// console.log("TOKEN IN INTERCEPTOR:", token);

//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// 📥 Response interceptor (error handle)
axiosHttp.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    // 🔐 Unauthorized → logout
    // if (response?.status === 401) {
    //   window.location.href = "/user/login"; // redirect
    // }

    // const errorData = response
    //   ? {
    //       data: response.data,
    //       status: response.status,
    //     }
    //   : {
    //       message: "Network Error",
    //     };

    // return Promise.reject(errorData);

     return Promise.reject(
      response || { message: "Network Error" }
    );
  }
);

export default axiosHttp;